import { render, staticRenderFns } from "./MicroApp.vue?vue&type=template&id=5a1773ba&scoped=true"
import script from "./MicroApp.vue?vue&type=script&lang=js"
export * from "./MicroApp.vue?vue&type=script&lang=js"
import style0 from "./MicroApp.vue?vue&type=style&index=0&id=5a1773ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1773ba",
  null
  
)

export default component.exports